import React, { useState, useEffect } from 'react';
import { Table, Tag, Button, message, Empty } from 'antd';
import { getAdoptionHistory } from '@/services/storeCalibration';

const STATUS_MAP = {
  0: { text: '未处理', color: 'default' },
  1: { text: '已采纳', color: 'green' },
  2: { text: '待人工核查', color: 'orange' },
  3: { text: '人工拒绝', color: 'red' },
};

const columns = [
  { title: '批次日期', dataIndex: 'batchDate', width: 110 },
  {
    title: '校准坐标', width: 230,
    render: (_, r) =>
      r.calibratedLongitude && r.calibratedLatitude
        ? `${r.calibratedLongitude.toFixed(7)}, ${r.calibratedLatitude.toFixed(7)}`
        : '-',
  },
  {
    title: 'MAD(m)', dataIndex: 'mad', width: 80,
    render: (v) => v?.toFixed(1) ?? '-',
  },
  {
    title: '偏差(m)', dataIndex: 'deviationDistance', width: 80,
    render: (v) => v?.toFixed(1) ?? '-',
  },
  {
    title: '采纳前坐标', width: 230,
    render: (_, r) =>
      r.adoptedFromLongitude && r.adoptedFromLatitude
        ? `${r.adoptedFromLongitude.toFixed(7)}, ${r.adoptedFromLatitude.toFixed(7)}`
        : '-',
  },
  {
    title: '采纳后坐标', width: 230,
    render: (_, r) =>
      r.adoptedToLongitude && r.adoptedToLatitude
        ? `${r.adoptedToLongitude.toFixed(7)}, ${r.adoptedToLatitude.toFixed(7)}`
        : '-',
  },
  {
    title: '状态', dataIndex: 'coordStatus', width: 110,
    render: (v) => (
      <Tag color={STATUS_MAP[v]?.color}>{STATUS_MAP[v]?.text || '未知'}</Tag>
    ),
  },
];

export default function AdoptionHistory({ storeId }) {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const handleLoad = async () => {
    if (!storeId) {
      message.warning('请先查询门店');
      return;
    }
    setLoading(true);
    const res = await getAdoptionHistory({ requestData: { storeId } });
    if (res?.code === '00000') {
      setRecords(res.data?.records || []);
    } else {
      message.error(res?.msg || '查询采纳历史失败');
    }
    setLoading(false);
    setLoaded(true);
  };

  // storeId 变化时清空数据
  useEffect(() => {
    setRecords([]);
    setLoaded(false);
  }, [storeId]);

  return (
    <div style={{ padding: '4px 0' }}>
      <div style={{ marginBottom: 12 }}>
        <Button onClick={handleLoad} loading={loading}>
          加载采纳历史
        </Button>
      </div>
      {!loaded ? (
        <Empty description="点击「加载采纳历史」查看数据" />
      ) : records.length === 0 ? (
        <Empty description="暂无采纳历史记录" />
      ) : (
        <Table
          dataSource={records}
          columns={columns}
          size="small"
          rowKey="batchDate"
          pagination={false}
          scroll={{ x: 1100 }}
        />
      )}
    </div>
  );
}
